import PropTypes from 'prop-types'
import React from 'react'
import { CookiesHelper } from 'SRC/core/cookiesHelper/CookiesHelper'
import { getIsTransitioning } from 'SRC/modules/common/selectors'
import { getAds } from '../../../selectors'
import { connect } from 'react-redux'
import { Item } from '../Item'
import { getProfileLoading, getProfileAdsError, getUserInfo } from 'SRC/modules/users/Profile/selectors'
import { Preloader } from 'SRC/ui/Preloader'
import { ErrorNotification } from 'SRC/ui/ErrorNotification'
import { setProfileAdsError, setCurrentStatusForAllAds, setPageForAllAds } from 'SRC/modules/users/Profile/actions'

export class List extends React.PureComponent {
  constructor(props) {
    super(props)

    this.cookies = new CookiesHelper()
    this.ref = React.createRef()
  }

  hideError = () => {
    this.props.setProfileAdsError('')
  }

  isUserPackageExpired = () => {
    if (this.props.user && this.props.user.packages) {
      const userPackage = this.props.user.packages[0]
      return !userPackage.activated || (userPackage.activated && userPackage.expired)
    }
  }

  showPackageExpiredError = () => {
    this.props.setProfileAdsError('Poštovani, Vaš paket je istekao. Ukoliko želite da aktivirate paket pozovite 067/312-555 ili 067/313-555.')
  }

  render() {
    const packageExpired = this.isUserPackageExpired()
    const { ads, isLoading, error, isAppTransitioning } = this.props

    const unpublishedAds = ads.filter(ad => ad.status === 'Unpublished')
    const publishedAds = ads.filter(ad => ad.status === 'Published')
    const pausedAds = ads.filter(ad => ad.status === 'Paused')
    const rejectedAds = ads.filter(ad => ad.status === 'Rejected')
    const soldAds = ads.filter(ad => ad.status === 'Sold')
    const expiredAds = ads.filter(ad => ad.status === 'Expired')

    const sortedAds = [...unpublishedAds, ...publishedAds, ...pausedAds, ...rejectedAds, ...soldAds, ...expiredAds]

    return (
      <div className='moji-oglasi-content' ref={this.ref}>
        {
          sortedAds.length && !isAppTransitioning
            ? sortedAds.map(ad => <Item key={ad.id} {...ad} packageExpired={packageExpired}
              showPackageExpiredError={this.showPackageExpiredError} />)
            : <div className='oglasi-content-text__no-ads-text'>Trenutno nema oglasa</div>
        }
        {isLoading ? <Preloader /> : null}
        <ErrorNotification hideNotification={this.hideError} error={error} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const user = getUserInfo(state)

  return {
    ads: getAds(state),
    isLoading: getProfileLoading(state),
    isAppTransitioning: getIsTransitioning(state),
    error: getProfileAdsError(state),
    user
  }
}

List.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  setProfileAdsError: PropTypes.func.isRequired,
  user: PropTypes.shape({
    packages: PropTypes.array.isRequired
  }).isRequired,
  isAppTransitioning: PropTypes.bool.isRequired,
  setCurrentStatusForAllAds: PropTypes.func.isRequired,
  setPageForAllAds: PropTypes.func.isRequired
}

List.defaultProps = {
  ads: [],
  isLoading: false
}

export default connect(mapStateToProps, {
  setProfileAdsError,
  setCurrentStatusForAllAds,
  setPageForAllAds
})(List)
